/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Usage_Overage_Alert_Preset_ButtonInputs */



/**
* | output |
* | --- |
* | "{pct}%" |
*
* @param {Usage_Overage_Alert_Preset_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_alert_preset_button = /** @type {((inputs: Usage_Overage_Alert_Preset_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Alert_Preset_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.pct} %`)
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
});